import { render } from "./RadiologyStageView.vue?vue&type=template&id=64941b7d"
import script from "./RadiologyStageView.vue?vue&type=script&lang=js"
export * from "./RadiologyStageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__